import fr from './fr'
import Utils from '../Utils'

var frMsg = {
  'agreements.title': 'Accords',
  'agreements.error.mandatory': "Vous devez accepter afin de pouvoir continuer à utiliser les services Deeper",
  'agreements.error.blank': "Veuillez faire un choix",
  'agreements.back': 'Retour',
  'agreements.agree': 'Accepter',
  'agreements.decline': 'Refuser',
  'agreements.text.full': 'Accord complet'
}

Utils.addTerms(frMsg, fr)

export default frMsg



// WEBPACK FOOTER //
// ./src/lang/frMsg.js